var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2818 9.97621L9.84878 10.6257C9.76235 10.7554 9.64804 10.866 9.4974 10.9058C9.00395 11.0362 7.69391 11.0951 5.69942 9.1006C3.70493 7.1061 3.7638 5.79605 3.89418 5.3026C3.93399 5.15196 4.04461 5.03765 4.17426 4.95122L4.82379 4.5182C5.30738 4.19581 5.43805 3.54243 5.11566 3.05884L3.88892 1.21873C3.60752 0.796629 3.06504 0.635365 2.59876 0.835199L2.04537 1.07237C1.62498 1.25253 1.28206 1.57587 1.07752 1.98495C0.906635 2.32673 0.774185 2.68663 0.75624 3.06833C0.699686 4.27119 0.963443 7.23469 4.26439 10.5356C7.56533 13.8366 10.5288 14.1003 11.7317 14.0438C12.1134 14.0258 12.4733 13.8934 12.815 13.7225C13.2241 13.5179 13.5475 13.175 13.7276 12.7546L13.9648 12.2012C14.1646 11.735 14.0034 11.1925 13.5813 10.9111L11.7412 9.68434C11.2576 9.36195 10.6042 9.49262 10.2818 9.97621Z",
    fill: "#596475"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneGrey);
export default __webpack_public_path__ + "static/media/phone_grey.dd0b8c322b31a5c0c8de3e72ab15d766.svg";
export { ForwardRef as ReactComponent };